import React, { useState } from "react";
import VideoCapture from "../VideoCapture/VideoCapture";
import ImageCapture from "../ImageCapture/ImageCapture";
import { EditOutlined } from "@ant-design/icons";
import { ManualInputArea } from "./QrCodeScanComponent";

enum Modes {
    VIDEO_CAPTURE = "video",
    IMAGE_CAPTURE = "image",
}

interface DynamSoftScanComponentProps {
    onScanSuccess: (text: string, frameDataUrl?: string) => void;
    onScanError?: (error: Error) => void;
    showManualInputIcon?: boolean;
    isPaused?: boolean;
}

const DynamSoftScanComponent: React.FC<DynamSoftScanComponentProps> = (props) => {
    const { showManualInputIcon = true, isPaused = false } = props;
    const [mode, setMode] = useState<Modes>(Modes.VIDEO_CAPTURE);
    const [manualInputVisible, setManualInputVisible] = useState(false);
    const [isPausedScanning, setIsPausedScanning] = useState(false);
    // 使用时间戳作为 VideoCapture 的 key，确保每次重新挂载都是全新实例
    const [videoCaptureKey] = useState<number>(() => Date.now());

    const handleManualInputVisible = (visible: boolean) => {
        setManualInputVisible(visible);
        setIsPausedScanning(visible);
    };

    return (
        <div className="flex h-full">
            {mode === Modes.VIDEO_CAPTURE ? (
                <>
                    <div className="w-full h-full">
                        <VideoCapture
                            key={videoCaptureKey}
                            onScanSuccess={props.onScanSuccess}
                            onScanError={props.onScanError}
                            isPaused={isPaused || isPausedScanning}
                        />
                    </div>
                    {showManualInputIcon && (
                        <div className="absolute bottom-2 right-4 flex gap-4">
                            <div
                                onClick={() => {
                                    console.log('EditOutlined clicked!');
                                    handleManualInputVisible(true);
                                }}
                                className='flex items-center justify-center w-8 h-8 rounded-full bg-white cursor-pointer'
                                style={{ zIndex: 1000 }}
                            >
                                <EditOutlined />
                            </div>
                        </div>
                    )}
                    {showManualInputIcon && (
                        <ManualInputArea
                            onScanSuccess={props.onScanSuccess}
                            visible={manualInputVisible}
                            setManualInputVisible={handleManualInputVisible} />
                    )}
                </>
            ) : (
                <div className="w-full h-full">
                    <ImageCapture />
                </div>
            )}
        </div>
    );
};

export default DynamSoftScanComponent;
